import React, { lazy } from "react";
import { useSelector } from "react-redux";
import withSuspense from "../../../../helpers/withSuspense.jsx";
import SkeletonGrid from "../../../../skeleton_loaders/common/SkeletonGrid.jsx";

const MapBox = withSuspense(lazy(() => import('./MapBox.jsx')), SkeletonGrid)

function MapVisualisationWidget({ widgetId }) {
    const settings = useSelector(state => state.dashboard.widgets[widgetId].settings)
    const loading = useSelector(state => state.dashboard.loading);

    return (
        loading ? <SkeletonGrid /> :
        <MapBox settings={settings} accessToken={settings.access_token} />
    )
}

export default MapVisualisationWidget;
